export const bureauRoutes = {
  dashboard: 'bureau/dashboard',
  organisations: '/bureau/organisations',
  teams: '/bureau/teams',
  users: '/bureau/users',
  reports: 'bureau/reports'
};
